import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Reveal, Eyebrow } from "./Reveal";
import { ArrowRight } from "lucide-react";
import { productPath } from "@/lib/seo";
import { displayTitle } from "@/lib/title";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

export const FeaturedProducts = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/products/featured`, { params: { limit: 8 } })
      .then((r) => setItems(r.data.items))
      .catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section data-testid="featured-products" className="py-24 lg:py-32 bg-white border-b border-[#E8DCC4]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-xl">
            <Eyebrow>Shop The Catalog</Eyebrow>
            <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-neutral-900" data-testid="featured-heading">
              Featured <span className="text-[#C9A227]">gold &amp; diamond</span> pieces
            </h2>
            <p className="mt-4 text-sm text-neutral-500">A fresh selection every visit — all in stock right now.</p>
          </div>
          <Link
            to="/catalog"
            data-testid="featured-browse-all"
            className="inline-flex items-center gap-2 text-sm font-semibold text-[#C9A227] hover:text-[#A8871B] transition-colors duration-300"
          >
            Browse the full catalog <ArrowRight size={16} strokeWidth={1.5} />
          </Link>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-8">
          {items.map((p, i) => (
            <Reveal key={p.sku} delay={0.05 * i}>
              <Link
                to={productPath(p)}
                data-testid={`featured-card-${p.sku}`}
                className="group block bg-[#FDFBF7] border border-[#E8DCC4] rounded-sm overflow-hidden hover:shadow-[0_20px_40px_rgb(201,162,39,0.10)] hover:-translate-y-1 transition-[box-shadow,transform] duration-500"
              >
                <div className="overflow-hidden">
                  <img
                    src={p.image_url}
                    alt={displayTitle(p)}
                    loading="lazy"
                    className="w-full h-[160px] sm:h-[200px] lg:h-[220px] object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                </div>
                <div className="p-4">
                  <p className="text-[10px] uppercase tracking-[0.15em] text-[#C9A227] font-semibold">{p.category}</p>
                  <h3 className="text-sm lg:text-base font-semibold text-neutral-900 mt-1 leading-snug line-clamp-2">
                    {displayTitle(p)}
                  </h3>
                  <p className="text-sm font-semibold text-neutral-800 mt-2">{money(p.retail_price)}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
